// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Introduce_style_wrap__2oUt4","title":"Introduce_style_title__1fhaj","grey":"Introduce_style_grey__2i7lt"};